import { put } from '@/services/put'

/**
 * URL : /jobs/:jobId/publish
 */
export function publishJob(jobId: string) {
  return put<{ id: string }, { id: string }>(`/jobs/${jobId}/publish`)
}
